import { render, staticRenderFns } from "./OrderListFix.vue?vue&type=template&id=f727ffba&"
import script from "./OrderListFix.vue?vue&type=script&lang=js&"
export * from "./OrderListFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports